import React, {useState} from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav,Container,NavDropdown, Dropdown} from 'react-bootstrap';
import { Text, NavLink,Modal } from '@mantine/core';

const TopNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const handleLogout = (e) => {
    e.preventDefault();
    navigate('/')
  };

  return (
    <>
    
    <Navbar
      collapseOnSelect
      expand="lg"
      style={{
        backgroundColor: '#801230',
        position: 'sticky',
        top: 0,
        zIndex: 10, 
        paddingTop: 2,   
        paddingBottom: 2 
      }}
    >
      <Container>
      <Navbar.Brand className="d-flex align-items-center">
        <div
          id="ecoe"
          onClick={() => navigate('/backoffice/home')}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <span
            style={{
              fontSize: '1.8rem',
              fontWeight: 900,
              color: '#fcf0f1',
            }}
          >
            UAI
          </span>
          <span
            style={{
              fontSize: '1rem', 
              fontWeight: 700,
              color: '#fcf0f1',
              marginLeft: 2,
              marginTop: 12,
            }}
          >
            .Inscripciones
          </span>
        </div>
      </Navbar.Brand>
      </Container>
    </Navbar>
    </>
  );
};
        


export default TopNavbar;
